import { useNavigate } from "react-router-dom";

const ACTIONS = [
  {
    label: "My Prescriptions",
    icon: "pi-file-edit",
    color: "blue",
    path: "/prescriptions",
    desc: "View & manage",
  },
  {
    label: "Upload Prescription",
    icon: "pi-upload",
    color: "teal",
    path: "/upload",
    desc: "Add new Rx",
  },
  {
    label: "Refill Requests",
    icon: "pi-refresh",
    color: "amber",
    path: "/refills",
    desc: "Track status",
  },
  {
    label: "Family Members",
    icon: "pi-users",
    color: "purple",
    path: "/relatives",
    desc: "Manage family",
  },
];

export default function QuickActionsCard() {
  const navigate = useNavigate();

  return (
    <div className="ph-card">
      <div className="ph-card-header">
        <div className="ph-card-title">
          <i className="pi pi-bolt" />
          Quick Actions
        </div>
      </div>
      <div className="quick-actions-grid">
        {ACTIONS.map((action) => (
          <button
            key={action.path}
            className="quick-action-btn"
            onClick={() => navigate(action.path)}
          >
            <div className={`quick-action-icon ${action.color}`}>
              <i className={`pi ${action.icon}`} />
            </div>
            <div>
              <div className="quick-action-label">{action.label}</div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 1 }}>
                {action.desc}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
